module.exports = __webpack_public_path__ + "assets/media/purple-arrow-1.ee35fde4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookDemoRequestStep/purple-arrow-1.svg
// module id = 3147
// module chunks = 0